module.exports = __webpack_public_path__ + "img/paas_wrapbg1.0a59881b.png";